module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/home/blank/blank.component.html
// module id = ./src/app/home/blank/blank.component.html
// module chunks = main